import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const member = {

    state: {

    },

    mutations: {

        getMemberLists(state, data) {
            data.url = API.member.getMemberLists;
            CommonUtils.GetRequest(data);
        },

        getMemberInfo(state, data) {
            data.url = API.member.getMemberInfo;
            CommonUtils.GetRequest(data);
        },

        editMember(state, data) {
            data.url = API.member.editMember;
            CommonUtils.PostRequest(data);
        },

        addMember(state, data) {
            data.url = API.member.addMember;
            CommonUtils.PostRequest(data);
        }

    }

};

export default member;


// WEBPACK FOOTER //
// ./src/store/modules/member.js